import React, { Component } from 'react';
import { Select, Button } from 'antd';
import SearchRetrieve from '../../../common/SearchRetrieve.new.js';
import API_URL from '../../../../common/url';

const { Option } = Select;

class Filter extends Component {
    constructor(props) {
        super(props);
        const { searchParams } = props;
        this.state = {
            searchParams
        };
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search(searchParams);
    }

    export = () => {
        const { searchParams } = this.state;
        this.props.export(searchParams);
    }

    showFixedLine = () => {
        this.ExportFixedLineRef.show()
    }

    handleChange = (option, key) => {
        const { searchParams } = this.state;
        const { text, value } = option;
        if (key === 'company') {
            searchParams.competingCompanyId = value;
            searchParams.competingCompanyName = text;
        } else if (key === 'hospital') {
            searchParams.hospitalId = value;
            searchParams.hospitalName = text;
            searchParams.departmentId = undefined;
            searchParams.departmentName = undefined;
        } else if (key === 'department') {
            searchParams.departmentId = value;
            searchParams.departmentName = text;
        }
        this.setState({ searchParams });
    }

    handleSelect = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams });
    }

    render () {
        const { curRole } = sessionStorage;
        const isPAPM = curRole == 'PA' || curRole == 'PM';
        const { update, setRecord, canEditByInvStatus, showStartTotalModal } = this.props;
        const { searchParams: { competingCompanyName, hospitalId, hospitalName, departmentName, siteIsStart } } = this.state;
        return (
            <div className="search-bar" style={{ marginBottom: 10 }}>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">公司名称</label>
                    <SearchRetrieve
                        keyword='companyName'
                        style={{ width: 162 }}
                        placeholder="输入公司名称检索"
                        value={competingCompanyName}
                        params={{ limit: 20 }}
                        url={API_URL.competeCompany.queryCompany}
                        config={{ id: 'competingCompanyId', name: 'companyName', type: 'competeCompany' }}
                        onChange={value => this.handleChange(value, 'company')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">医院名称</label>
                    <SearchRetrieve
                        keyword='hospitalName'
                        style={{ width: 162 }}
                        placeholder="输入医院名称检索"
                        value={hospitalName}
                        params={{ limit: 20 }}
                        url={API_URL.hospital.hospitalList}
                        config={{ id: 'hospitalId', name: 'hospitalName' }}
                        onChange={value => this.handleChange(value, 'hospital')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">科室</label>
                    <SearchRetrieve
                        keyword='hospitalDepName'
                        style={{ width: 162 }}
                        placeholder="输入科室名称检索"
                        disabled={!hospitalId}
                        value={departmentName}
                        params={{ limit: 20, hospitalId }}
                        url={API_URL.hospital.queryDepWhenAddDoctor}
                        config={{ id: 'hospitalDepartmentId', name: 'departmentLocalName' }}
                        onChange={value => this.handleChange(value, 'department')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">中心是否已启动</label>
                    <Select
                        placeholder="请选择"
                        value={siteIsStart ? String(siteIsStart) : undefined}
                        style={{ width: 80 }}
                        onChange={value => this.handleSelect(value, 'siteIsStart')}
                    >
                        <Option value="1">是</Option>
                        <Option value="0">否</Option>
                    </Select>
                </div>
                <div className="search-item">
                    <Button type="primary" onClick={this.search}>搜索</Button>
                    <Button type="primary" onClick={this.export}>导出</Button>
                    { isPAPM && <Button type="primary" onClick={() => canEditByInvStatus(() => update())}>添加竞争公司中心</Button> }
                    { isPAPM && <Button type="primary" onClick={() => canEditByInvStatus(() => setRecord())} style={{background:'#fc0',border:'1px solid #f93'}}>设置入组情况记录方式</Button> }
                    { curRole == 'PM' && <Button type="primary" onClick={() => canEditByInvStatus(() => showStartTotalModal())}>添加竞争公司启动入组总数</Button> }
                </div>
            </div>
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/competeCompany/Performance/components/Filter.js